import { TranslateFunc } from '@ha/intl';

export function getTenantStatusTitle(T: TranslateFunc, status: string): string {
  switch (status) {
    case 'working professionals only':
      return `, ${T('working professionals only')}`;
    case 'students only':
      return `, ${T('students only')}`;
    case 'any':
      return `, ${T('students and working professionals')}`;
    default:
      return `. ${T('Suitable for %s', status)}`;
  }
}
